import React from 'react';
import PropTypes from 'prop-types';
import Loader from './loader';
import { connect } from 'react-redux';
import { authorizedRequest } from '../../request';
import { createStructuredSelector } from 'reselect';
import { makeSelectCurrentUserToken, makeSelectCurrentSite } from '../App/selectors';
import RecommendationsList from '../../components/RecommendationsList';
import messages from './messages';
import { injectIntl } from 'react-intl';

export class FolderRecommendations extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      folder: null,
      url: null,
    };
  }

  componentDidMount() {
    this.loadRecommendations();
  }
  
  loadRecommendations() {
    const requestURL = `/widgets/${this.props.site}/recommended_folders`;
    authorizedRequest(requestURL, this.props.token)
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result.data,
            folder: result.folder_name,
            url: result.folder_url,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      );
  }

  recommendationsToListItem() {
    return this.state.items.map((item, index) => (
      {
        id: index,
        title: item.title,
        description: item.type,
        image: item.image,
        url: item.url,
      }
    ));
  }

  render() {
    if (!this.state.isLoaded) {
      return (
        <Loader />
      );
    }
    return (
      <RecommendationsList
        listTitle={this.props.intl.formatMessage(messages['title'], { folder: this.state.folder, url: this.state.url})}
        items={this.recommendationsToListItem(this.state.items)}
      />
    );
  }
}

FolderRecommendations.propTypes = {
};

const mapArticlesStateToProps = createStructuredSelector({
  token: makeSelectCurrentUserToken(),
  site: makeSelectCurrentSite(),
});

export default connect(mapArticlesStateToProps)(injectIntl(FolderRecommendations));
